import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { setupListeners } from '@reduxjs/toolkit/query';
import rootReducer from '../store/rootReducer';
import { baseApi } from './baseApi';
import { notificationApi } from '../features/notifications/notificationsAPI';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 
  'currentMeeting', 
  'currentFamily',
  'calendarFilters', 
  'users'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(baseApi.middleware)
      .concat(notificationApi.middleware)

});

setupListeners(store.dispatch);

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
